// Simple localStorage helper (SSR-safe)
export const storage = {
  get(key, fallback) {
    try {
      if (typeof window === "undefined") return fallback;
      const raw = window.localStorage.getItem(key);
      if (raw == null) return fallback;
      return JSON.parse(raw);
    } catch {
      return fallback;
    }
  },
  set(key, value) {
    try {
      if (typeof window === "undefined") return;
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* ignore quota errors */
    }
  },
  remove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  },
};

export const STORAGE_KEYS = {
  checklist: "elba.checklist.v1",
  diary: "elba.diary.v1",
  extraItems: "elba.extraItems.v1",
};
